<app-scaffold
  icon="streamline:app-window-error-404"
  [title]="'ERROR.NOT_FOUND.TITLE' | translate"
  [content]="'ERROR.NOT_FOUND.CONTENT' | translate"
  [actionLabel]="'ERROR.GO_HOME' | translate"
  actionLink="/"
>
</app-scaffold>
